import Discount from './discount';
import ModelPosition from './model-position';
import NonEmptyText from './non-empty-text';
import NonNegativeNumber from './non-negative-number';
import Position from './position';
import PositiveInteger from './positive-integer';
import Price from './price';
import Currency from './sales/currency';
import OrderType from './sales/order-type';
import Store from './sales/store';
import UUID from './sales/uuid';
import Workflow from './sales/workflow';
import TextPosition from './text-position';

export function assertIsInstanceOfArray(value: unknown): asserts value is Array<unknown> {
	if (Array.isArray(value)) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Array`);
}

export function assertIsInstanceOfCurrency(value: unknown): asserts value is Currency {
	if (value instanceof Currency) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Currency`);
}

export function assertIsInstanceOfDate(value: unknown): asserts value is Date {
	if (value instanceof Date) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Date`);
}

export function assertIsInstanceOfDateOrNull(value: unknown): asserts value is Date | null {
	if (value instanceof Date || value === null) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Date or null`);
}

export function assertIsInstanceOfDiscountOrNull(value: unknown): asserts value is Discount | null {
	if (value instanceof Discount || value === null) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Discount or null`);
}

export function assertIsInstanceOfNonEmptyText(value: unknown): asserts value is NonEmptyText {
	if (value instanceof NonEmptyText) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of NonEmptyText`);
}

export function assertIsInstanceOfNonEmptyTextOrNull(value: unknown): asserts value is NonEmptyText | null {
	if (value instanceof NonEmptyText || value === null) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of NonEmptyText or null`);
}

export function assertIsInstanceOfNonNegativeNumber(value: unknown): asserts value is NonNegativeNumber {
	if (value instanceof NonNegativeNumber) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of NonNegativeNumber`);
}

export function assertIsInstanceOfOrderType(value: unknown): asserts value is OrderType {
	if (value instanceof OrderType) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of OrderType`);
}

export function assertIsInstanceOfPositiveInteger(value: unknown): asserts value is PositiveInteger {
	if (value instanceof PositiveInteger) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of PositiveInteger`);
}

export function assertIsInstanceOfPrice(value: unknown): asserts value is Price {
	if (value instanceof Price) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Price`);
}

export function assertIsInstanceOfStore(value: unknown): asserts value is Store {
	if (value instanceof Store) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Store`);
}

export function assertIsInstanceOfUUID(value: unknown): asserts value is UUID {
	if (value instanceof UUID) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of UUID`);
}

export function assertIsInstanceOfWorkflow(value: unknown): asserts value is Workflow {
	if (value instanceof Workflow) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Workflow`);
}

export function assertIsNonEmptyString(value: unknown): asserts value is string {
	if (typeof value === 'string' && value.length > 0) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be a non empty string`);
}

export function assertIsNonNegativeNumber(value: unknown): asserts value is number {
	if (typeof value === 'number' && Number(value) >= 0) {
		return;
	}
	throw new RangeError(`[${String(value)}] is invalid, must be a non negative number`);
}

export function assertIsPositionOrNull(value: unknown): asserts value is null | Position {
	if (value instanceof Position || value === null) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Position or null`);
}

export function assertIsPositiveInteger(value: unknown): asserts value is number {
	if (Number.isInteger(value) && Number(value) >= 1) {
		return;
	}
	throw new RangeError(`[${String(value)}] is invalid, must be a positive integer`);
}

export function assertIsUUID(value: unknown): asserts value is string {
	// Define the UUIDv4 regex
	const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	if (typeof value === 'string' && regex.test(value)) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be UUID V4 format`);
}

export function assertIsValidPositions(value: unknown): asserts value is Array<ModelPosition | TextPosition> {
	if (Array.isArray(value) === false) {
		throw new TypeError(`[${String(value)}] is invalid, must be instance of Array`);
	}
	for (const position of value) {
		if (position instanceof ModelPosition || position instanceof TextPosition) {
			// we are good, but don't return out of the loop
		} else {
			throw new TypeError(`[${String(value)}] is invalid, must be instance of ModelPositions or TextPositions`);
		}
	}
}
